import React, { useState } from 'react'
import {
    Button,
    Table,
    Tr,
    Flex,
    PageWrapper,
    PageFooter,
    Th,
    H1WithBack,
} from '../../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { ModalTypes } from 'types/global.interface'
import { BreakTemplatesModal } from './BreakTemplatesModal'
import { clearBreakTemplates, deleteBreakTemplate, getBreakTemplates } from 'features/breaks/breaksSlice'

export const BreakTemplates: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>()
    const [modal, setModal] = useState({ open: false, value: null })
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const { data, totalPages } = useSelector((state: RootState) => state.breaks.templates)

    useQueryPagination({ fetchFunctions: [getBreakTemplates], cleanUpFunctions: [clearBreakTemplates], params })

    const handleRemove = (id: string) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteBreakTemplate(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: data.length < 2,
                },
                word: 'delete templete',
            }),
        )
    }

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center mb='16' >
                    <H1WithBack arrow title='Templates' />
                    <Button orange onClick={() => setModal({ open: true, value: null })}>
                        Add Template
                    </Button>
                </Flex>
                {!data?.length ? (
                    <NoItems title='Templates' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='20%' noTooltip text='NAME' />
                            <Td w='75%' noTooltip text='NUMBER OF BREAKS' />
                            <Td w='5%' />
                        </Th>
                        {
                            data.map((item) => {
                                return (
                                    <Tr key={item.id}>
                                        <Td w='20%' text={item.name} />
                                        <Td w='75%' text={item?.breaks?.length} />
                                        <Td options w='5%'>
                                            <Options item={item} openModal={() => setModal({ open: true, value: item })} title='Break Templates' handleRemove={handleRemove} />
                                        </Td>
                                    </Tr>
                                )
                            })}
                    </Table>
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
            {modal.open && <BreakTemplatesModal value={modal.value} closeModal={() => setModal({ open: false, value: null })} />}
        </>
    )
}
